import React from 'react';
import {connect} from 'react-redux';
import {BaseFilterComponent} from 'components/organisms/used-players-list/components/filter/game-types/tiers';

class FilterComponent extends BaseFilterComponent {
    render() {
        const tabs = this.prepareTabs();
        return <div className="tabs-chk-fixed">{tabs}</div>;
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        playersData: {slates},
    } = state;
    return {
        filters: state.usedPlayers.filters,
        slate: slates.getById(sportConfig.getSlateId()),
    };
}

const Filter = connect(mapStatesToProps)(FilterComponent);

export {Filter};
